import React from 'react';
import ProductForm from '../components/Products/ProductForm';
import ProductList from '../components/Products/ProductList';

const ProductsPage = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900">Activities Management</h1>
        <p className="text-gray-600 mt-2">
          Manage your EHS activities with risk-based weighting factors
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <ProductForm />
        <ProductList />
      </div>
    </div>
  );
};

export default ProductsPage;
